import React, {useEffect, useRef} from "react"
import config from '../../config'
import GamePageLayout from '../../components/GamePageLayout';
import './styles.css'
import { navigate } from "gatsby";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../redux/actions";
import {IFRAME_ACTION_CLEAR,IFRAME_ACTION_PERSIST} from "../../redux/Iframe/iframe.constant";
import GameNavbar from "../../components/GameNavbar";
/**
 * @author Bahar Abadi
 */
const IframePage =(props)=> {

    const { link , backUrl } = useSelector(state => state.iframe);

    const dispatch = useDispatch();

    const updateState = state => {
        dispatch(persist(state, IFRAME_ACTION_PERSIST));
    };

    useEffect(()=>{
        const {location} = props
        const {state} = location
        let hash = (new Date()).getTime()
         if(state && state.url){
         let version = state.url.indexOf("?")>-1 ? `&v=${hash}` : `?v=${hash}`
        updateState({link:state.url + version , backUrl:state.backUrl})
        }
        else if(link==null && !(state && state.url))
          navigate("/")
    },[link])


        return <GamePageLayout type={IFRAME_ACTION_CLEAR} >
            <GameNavbar backUrl={backUrl} page="webView"/>
            {link && <iframe   className="baziigramFrame" name="baziigramFrame"  src={link}/>}
            {link==null && <div className="d-flex flex-column h-100 justify-content-center align-items-center"><div
                className={"baziigramSpinner mt-5 spinner-border text-light"}
                role="status"
            ></div></div>}
        </GamePageLayout>



    // _handleBack = () => {
    //     window.history.back();
    //     return false
    // }
}

export default IframePage
